/**
 * Das Mikrofon-Zeichen — EINE Form für alle Knöpfe, die ein Mikrofon bedienen (Bild-Beschriftung, Textfelder,
 * Morse „Sprechen“). (08.10.2026, aus feld-mikrofon.ts herausgelöst)
 *
 * Nur Bild (aria-hidden): der Name steht am Knopf. Farbe und Strich kommen von `currentColor`, die Größe aus dem Aufruf —
 * ⚠️ keine Inline-Styles, nur SVG-Attribute.
 */
const NS = "http://www.w3.org/2000/svg";

export function mikrofonZeichen(groesse = 20): SVGSVGElement {
  const svg = document.createElementNS(NS, "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("width", String(groesse));
  svg.setAttribute("height", String(groesse));
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("stroke-width", "1.8");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("aria-hidden", "true");
  const korpus = document.createElementNS(NS, "rect");
  korpus.setAttribute("x", "9");
  korpus.setAttribute("y", "3");
  korpus.setAttribute("width", "6");
  korpus.setAttribute("height", "11");
  korpus.setAttribute("rx", "3");
  const buegel = document.createElementNS(NS, "path");
  buegel.setAttribute("d", "M5 11a7 7 0 0014 0M12 18v3");
  svg.appendChild(korpus);
  svg.appendChild(buegel);
  return svg;
}
